import { ButtonManager } from './ButtonManager.js';

export const FormValidation = {

  formSelector: 'form:not(.disable-parsley-validation)',
  phoneNumberSelector: '#phone-input',
  countrySelectSelector: '#phone-select',

  parsleyOptions: {
    classHandler: function (ParsleyField) {
      var $errorClassElement;
      switch (ParsleyField.$element.prop('type')) {
        case 'checkbox':
          $errorClassElement = ParsleyField.$element.closest('label');
          break;
        default:
          $errorClassElement = ParsleyField.$element.closest('.input');
      }
      return $errorClassElement;
    },
    errorsContainer: function errorsContainer (ParsleyField) {
      var $errorsContainerElement;
      switch (ParsleyField.$element.prop('type')) {
        case 'checkbox':
          $errorsContainerElement = ParsleyField.$element.closest('label');
          break;
        default:
          $errorsContainerElement = ParsleyField.$element.closest('.input');
      }
      return $errorsContainerElement;
    },
    errorClass: 'error',
    errorsWrapper: '<div class="note note-error"></div>',
    errorTemplate: '<span></span>'
  },

  initCustomValidations: function () {
    window.Parsley.addValidator('maxage', function (value, requirement) {
      if (value != '') {
        var input = value.split('.');
        if (input.length !== 3) {
          return false;
        } else {
          var currentYear = new Date().getFullYear();
          if ((currentYear - parseInt(input[2])) >= 100) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    });
    window.Parsley.addValidator('phoneNumber', function () {
      const $countrySelect = $(FormValidation.countrySelectSelector).val();
      const $rawInput = $(FormValidation.phoneNumberSelector).val();
      const phoneNumber = libphonenumber.parsePhoneNumberFromString($rawInput, $countrySelect);
      return !!phoneNumber && phoneNumber.isValid() && phoneNumber.country === $countrySelect;
    });
  },

  lowercaseEmailAddress: function () {
    var $emailInput = $('input[type=email]');
    $emailInput.on('focusout', function () {
      var $this = $(this);
      var newVal = $this.val().toLowerCase();
      $this.val(newVal);
    });
  },

  initializePreventDoubleSubmissions: function () {
    window.Parsley.on('form:submit', function () {
      var $form = this.$element;
      if ($form.data('submitted') === true) {
        return false;
      } else {
        $form.data('submitted', true);
      }
    });
  },

  initializeCustomLanguageMessages: function () {
    window.Parsley.addMessages('de', {
      defaultMessage: 'Die Eingabe scheint nicht korrekt zu sein.',
      type: {
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        url: 'Bitte geben Sie eine gültige URL ein.',
        number: 'Die Eingabe muss eine Zahl sein.',
        integer: 'Die Eingabe muss eine Zahl sein.',
        digits: 'Die Eingabe darf nur Ziffern enthalten.',
        alphanum: 'Die Eingabe muss alphanumerisch sein.'
      },
      notblank: 'Die Eingabe darf nicht leer sein.',
      required: 'Dies ist ein Pflichtfeld.',
      pattern: 'Die Eingabe scheint ungültig zu sein.',
      min: 'Die Eingabe muss grösser oder gleich %s sein.',
      max: 'Die Eingabe muss kleiner oder gleich %s sein.',
      range: 'Die Eingabe muss zwischen %s und %s liegen.',
      minlength: 'Die Eingabe ist zu kurz. Bitte geben Sie mindestens %s Zeichen ein.',
      maxlength: 'Die Eingabe ist zu lang. Bitte geben Sie höchstens %s Zeichen ein.',
      length: 'Die Länge der Eingabe ist ungültig. Bitte geben Sie zwischen %s und %s Zeichen ein.',
      mincheck: 'Bitte wählen Sie mindestens %s Angaben aus.',
      maxcheck: 'Bitte wählen Sie maximal %s Angaben aus.',
      check: 'Bitte wählen Sie zwischen %s und %s Angaben.',
      equalto: 'Dieses Feld muss dem anderen entsprechen.',
      remote: 'Diese Eingabe scheint nicht korrekt zu sein',
    });
    window.Parsley.setLocale('de');
  },
  dynamicPhoneValidation: function () {
    const $countrySelect = $(FormValidation.countrySelectSelector);
    const $phoneInput = $(FormValidation.phoneNumberSelector);

    function updatePattern () {
      addParsedPhoneNumber();

      $phoneInput.attr('data-parsley-error-message', 'Bitte geben Sie eine gültige Telefonnummer ein.');

      if ($phoneInput.length) {
        const instance = $phoneInput.parsley();
        if (instance) {
          if ($phoneInput.parent().hasClass('error')) {
            instance.validate();
          }
        }
      }
    }

    function initAddParsedPhoneNumber () {
      const phoneNumber = $phoneInput.val();
      if (phoneNumber) {
        const parsedPhoneNumber = libphonenumber.parsePhoneNumberFromString(phoneNumber);
        const isInitialized = $countrySelect.next('.dropdown-menu').length > 0;

        if (isInitialized) {
          $countrySelect.selectpicker('val', parsedPhoneNumber.country);
        } else {
          $countrySelect.one('loaded.bs.select', function () {
            $countrySelect.selectpicker('val', parsedPhoneNumber.country);
          });
        }
      }
    }

    function addParsedPhoneNumber () {
      const phoneNumber = $phoneInput.val();
      const countryCode = $countrySelect.val();

      if (phoneNumber) {
        const parsedPhoneNumber = libphonenumber.parsePhoneNumberFromString(phoneNumber, countryCode);
        if (parsedPhoneNumber) {
          const $hiddenField = $phoneInput.siblings('input[type="hidden"]');
          $hiddenField.val(parsedPhoneNumber.number);
        }
      }
    }

    function validatePhoneNumber () {
      const phoneNumber = $phoneInput.val();
      if (phoneNumber && $phoneInput.length) {
        const instance = $phoneInput.parsley();
        instance.validate();
        updatePattern();
      }
    }

    // parsley validation
    $phoneInput.on('focusout', validatePhoneNumber);
    $countrySelect.on('change', validatePhoneNumber);
    // update hidden input field
    $phoneInput.on('input', addParsedPhoneNumber);
    // initial
    updatePattern();
    initAddParsedPhoneNumber();
  },

  init: function () {
    FormValidation.initializeCustomLanguageMessages();
    FormValidation.initCustomValidations();
    FormValidation.lowercaseEmailAddress();
    FormValidation.initializePreventDoubleSubmissions();
    FormValidation.dynamicPhoneValidation();

    var $form = $(FormValidation.formSelector);
    if ($form.length > 0) {
      $form.each(function () {
        $(this).parsley(FormValidation.parsleyOptions).on('form:error', function () {
          ButtonManager.resetSingleClickButtons();
        });
      });
    }
  }
};
